export const LOAD_RES_RECORDS = 'LOAD_RES_RECORDS';
export const DATAKIT_LIST = 'DATAKIT_LIST';
export const REMOVE_LIST = 'REMOVE_LIST';
export const RESOURCE_LOADER = 'RESOURCE_LOADER';
export const BULK_DATA_DWN_FLAG = 'BULK_DATA_DWN_FLAG';
export const PAGINATION = 'PAGINATION';
